module.exports = __webpack_public_path__ + "img/pic_india_06.3ed2ee22.jpg";